// Application-wide constants
export const POLLING_INTERVAL_MS = 15000;
export const GUARD_POLLING_INTERVAL_MS = 10000;
export const DEFAULT_EXTEND_MINUTES = 30;
export const DEFAULT_DURATION_MINUTES = 30;
export const MIN_DURATION_MINUTES = 15;
export const DURATION_OPTIONS = [30, 60, 120, 180];
export const OTP_EXPIRY_MINUTES = 5;
export const HTTP_FORBIDDEN = 403;

export const APPROVAL_STYLES = {
  approved: { bg: '#D1FAE5', color: '#065F46' },
  pending: { bg: '#FEF3C7', color: '#92400E' },
  rejected: { bg: '#FEE2E2', color: '#991B1B' },
};

export const NOTIFICATION_COLORS = {
  checkin: '#FEF9C3',
  extension: '#DBEAFE',
  checkout: '#ECFDF5',
};

export const PAYMENT_STATUS_STYLES = {
  paid: { bg: '#10B981', color: '#FFFFFF' },
  active: { bg: '#FBBF24', color: '#09090B' },
  default: { bg: '#E4E4E7', color: '#09090B' },
};
